<template>
  <b-table
    :fields="table.fields"
    :items="items"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    striped
    hover
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default">
        <b-dropdown-item @click="confirmarExclusao(item)">
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

export default {
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      table: {
        fields: [
          {
            key: 'descricao',
            label: this.$t('SUPRIMENTOS.TIPO_IMPOSTO'),
            sortable: true,
          },
          {
            key: 'valor',
            label: this.$t('SUPRIMENTOS.VALOR'),
            formatter: (value) => {
              return value ? helpers.formatarReal(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'acoes',
            label: this.$t('SUPRIMENTOS.ACOES'),
          },
        ],
      },
    };
  },
  methods: {
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('GERAL.CONFIRMAR_EXCLUSAO'),
        this.$t('GERAL.CONFIRMAR_EXCLUSAO_ITEM').formatUnicorn({
          item: this.$t('SUPRIMENTOS.IMPOSTO'),
        })
      );
      respostaExclusao.isConfirmed ? this.excluir(item) : {};
    },
    excluir(item) {
      this.$emit('remover', item);
      this.items.splice(item.index, 1);
    },
  },
};
</script>
